import { getCustomerPath } from "portal/utils/routing";
import { Link } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import CustomerIcon from "@mui/icons-material/WorkOutlineOutlined";
import React, { FC, PropsWithChildren } from "react";

interface Props {
  customerUuid?: string;
}

export const CustomerLink: FC<PropsWithChildren<Props>> = ({
  customerUuid,
  children,
}) => (
  <Link
    component={RouterLink}
    to={getCustomerPath(customerUuid)}
    underline="always"
    color="inherit"
    className="inline-flex items-center gap-1 align-middle ml-1"
  >
    <CustomerIcon fontSize="small" />
    {children}
  </Link>
);
